<template>
  <div ref="switcherEl" class="language-switcher">
    <button
      type="button"
      class="language-switch-button"
      :title="language.t('common.switchLanguage')"
      :aria-label="language.t('common.switchLanguage')"
      :aria-expanded="menuOpen ? 'true' : 'false'"
      @click="toggleMenu"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M3.5 12h17"></path>
        <path d="M12 3c2.2 2.5 3.4 5.5 3.4 9s-1.2 6.5-3.4 9"></path>
        <path d="M12 3c-2.2 2.5-3.4 5.5-3.4 9s1.2 6.5 3.4 9"></path>
      </svg>
    </button>

    <section v-if="menuOpen" class="language-menu" :aria-label="language.t('common.language')">
      <button
        v-for="item in languageOptions"
        :key="item.key"
        type="button"
        class="language-option"
        :class="{ active: item.key === language.current }"
        @click="selectLanguage(item.key)"
      >
        <span class="language-check" aria-hidden="true">{{ item.key === language.current ? '✓' : '' }}</span>
        <img class="language-flag" :src="item.flagSrc" :alt="item.flagLabel" loading="lazy" decoding="async">
        <span class="language-name">{{ item.menuLabel || item.native }}</span>
      </button>
    </section>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { languageOptions, useLanguageStore } from '@/stores/language';

const language = useLanguageStore();
const menuOpen = ref(false);
const switcherEl = ref(null);

function toggleMenu() {
  menuOpen.value = !menuOpen.value;
}

function closeMenu() {
  menuOpen.value = false;
}

function selectLanguage(key) {
  language.setLanguage(key);
  closeMenu();
}

function handlePointerDown(event) {
  if (!menuOpen.value || switcherEl.value?.contains(event.target)) {
    return;
  }
  closeMenu();
}

function handleKeydown(event) {
  if (event.key === 'Escape') {
    closeMenu();
  }
}

onMounted(() => {
  document.addEventListener('pointerdown', handlePointerDown);
  document.addEventListener('keydown', handleKeydown);
});

onBeforeUnmount(() => {
  document.removeEventListener('pointerdown', handlePointerDown);
  document.removeEventListener('keydown', handleKeydown);
});
</script>
